import { paytmConstants } from '../Constants';

export function paytm(state = {}, action) {
    switch (action.type) {
        case paytmConstants.GET_LOAN_DETAILS_REQUEST:
            return {
                ...state,
                loading: true
            };
        case paytmConstants.GET_LOAN_DETAILS_SUCCESS:
            return {
                ...state,
                loading: false,
                items: action.loan
            };
        case paytmConstants.GET_LOAN_DETAILS_FAILURE:
            return {
                ...state,
                loading: false,
                error: 'message' in action.error ? action.error.message : action.error
            };
        case paytmConstants.POST_INITIAL_ORDER_REQUEST:
            return {
                ...state,
                postloading: true
            };
        case paytmConstants.POST_INITIAL_ORDER_SUCCESS:
            return {
                ...state,
                postloading: true,
                Items: action.initialOrder
            };
        case paytmConstants.POST_INITIAL_ORDER_FAILURE:
            return {
                ...state,
                postloading: false,
                posterror: 'message' in action.error ? action.error.message : action.error
            };
         case paytmConstants.VALIDATE_PAYMENT_LINK_REQUEST:
            return {
                ...state,
                postloading: true
            };
        case paytmConstants.VALIDATE_PAYMENT_LINK_SUCCESS:
            return {
                ...state,
                postloading: true,
                uuidInfo: action.paymentInfo
            };
        case paytmConstants.VALIDATE_PAYMENT_LINK_FAILURE:
            return {
                ...state,
                postloading: false,
                posterror: 'message' in action.error ? action.error.message : action.error
            };
        case paytmConstants.PAYTM_ERROR_CLEAR_ALL:
            return {};
        default:
            return state
    }
}